import styled from "styled-components";
import { colors } from "@/theme";

export const ProductCartTotalContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  padding: 16px 24px;
  border-top: ${`1px solid ${colors.black}`};
`;

export const ProductCartTotalCoopContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  border-radius: 12px;
  border: ${`1px solid ${colors.doveGray}`};
`;

export const ProductCartTotalCoopLabel = styled.div`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 12px 12px 0px 0px;
  background: ${colors.platinum};
  background-blend-mode: darken;
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ProductCartTotalCoopValue = styled.div`
  display: flex;
  padding: 16px;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ProductCartTotalAmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  border-radius: 12px;
  border: ${`1px solid ${colors.doveGray}`};
`;

export const ProductCartTotalAmountLabel = styled.div`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 12px 12px 0px 0px;
  background: ${colors.platinum};
  background-blend-mode: darken;
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ProductCartTotalAmountValue = styled.div`
  display: flex;
  padding: 16px;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
